import React, { useRef, useState, FormEvent } from "react";
import { useMediaQuery } from "react-responsive";

import emailjs from "@emailjs/browser";
import styles from "../styles/ContactForm.module.css";

type Category = "A-General" | "B-Booking" | "C-Hiring-Other" | "";

interface FormFields {
	user_name: string;
	user_email: string;
	user_phone: string;
	category: Category;
	message: string;
	subject: string;
}

const ContactForm = () => {
	const isMobile = useMediaQuery({ maxWidth: 767 });
	const formRef = useRef<HTMLFormElement | null>(null);
	const [loading, setLoading] = useState(false);
	const [sent, setSent] = useState(false);
	const [category, setCategory] = useState<Category>("");

	const sendEmail = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		if (!category) {
			alert("Select Category.");
			return;
		}

		if (!formRef.current) return;

		const formData = new FormData(formRef.current);
		const formValues: FormFields = {
			user_name: formData.get("user_name") as string,
			user_email: formData.get("user_email") as string,
			user_phone: formData.get("user_phone") as string,
			category: category,
			message: formData.get("message") as string,
			subject: category ? `[${category}] Inquiry` : "",
		};
		if (!formValues.category) {
			alert("Select Category.");
			return;
		}

		setLoading(true);

		emailjs
			.send(
				process.env.REACT_APP_EMAILJS_SERVICE_ID as string,
				process.env.REACT_APP_EMAILJS_TEMPLATE_ID as string,
				formValues as unknown as Record<string, unknown>
			)
			.then(
				() => {
					setLoading(false);
					setSent(true);
					formRef.current?.reset();
					setCategory("");
				},
				(error) => {
					setLoading(false);
					alert("Failed to send: " + error.text);
				}
			);
	};

	return (
		<div className={styles.container} data-mobile={isMobile}>
			<h2>📧 Exceptional Talent Wanted. Inquire Now.</h2>

			{!sent ? (
				<form ref={formRef} onSubmit={sendEmail} className={styles.form}>
					<label>Name</label>
					<input type="text" name="user_name" required />

					<label>Email</label>
					<input type="email" name="user_email" required />

					<label>Phone</label>
					<input type="tel" name="user_phone" placeholder="000-000-0000" required />

					<label>Inquiry Type <strong>*</strong></label>
					<select
						name="category"
						value={category}
						onChange={(e) => setCategory(e.target.value as Category)}
						required
					>
						<option value="">-- Select --</option>
						<option value="A-General">General Inquiry</option>
						<option value="B-Booking">Booking</option>
						<option value="C-Hiring-Other">Hiring / Other</option>
					</select>

					<label>Inquiry</label>
					<textarea
						name="message"
						placeholder="Please detail your service inquiry, desired date, or any specific concerns."
						required
					/>

					<input
						type="hidden"
						name="subject"
						value={category ? `[${category}] Inquiry` : ""}
					/>

					<button type="submit" disabled={loading || !category}>
						{loading ? "Sending..." : "Send"}
					</button>
				</form>
			) : (
				<p className={styles.success}>✅ Sent email successfully!</p>
			)}
		</div>
	);
};

export default ContactForm;